// extracted by mini-css-extract-plugin
module.exports = {"Heading":"BreakpointHeading_Heading__9avHm","Label":"BreakpointHeading_Label__JfecP"};